import PromptDialog from "@components/PromptDialog";
import React, { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface TokenExpiredContextType {
  showTokenExpired: (message: string) => void;
}

const TokenExpiredContext = createContext<TokenExpiredContextType | undefined>(
  undefined
);

export const TokenExpiredProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { logout, name } = useAuth();

  const handleConfirm = () => {
    setIsOpen(false);
    // Redirect to login page when the user confirms
    logout();
  };

  const showTokenExpired = (message: string) => {
    setMessage(message);
    setIsOpen(true);
  };

  return (
    <TokenExpiredContext.Provider value={{ showTokenExpired }}>
      {children}
      {isOpen && (
        <PromptDialog
          handleConfirm={handleConfirm}
          isOpen={isOpen}
          title={t("general.tokenExpired")}
          description={t("general.tokenExpiredMessage")}
        />
      )}
    </TokenExpiredContext.Provider>
  );
};

// Custom hook to use the context
export const useTokenExpired = () => {
  const context = useContext(TokenExpiredContext);
  if (!context) {
    throw new Error(
      "useTokenExpired must be used within a TokenExpiredProvider"
    );
  }
  return context;
};
